import { CloneFormService } from "./clone-form.service";
import { CloneSectionService } from "./clone-section.service";
import { CloneQuestionService } from "./clone-question.service";
import { Injectable, Injector } from "@angular/core";
import { Logger } from "src/app/core/logger";
import { ValdnWidgetsDateModel } from "src/app/models/widgets-validation/valdn-widgets-date.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { WidgetsClassEnum, WidgetsConfigController, WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsArrayModel } from "src/app/models/widgets/widgets-array.model";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsTextModel } from "src/app/models/widgets/widgets-text.model";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";
import { WidgetsService } from "../widgets/widgets.service";
import { ValdnWidgetsYearModel } from "src/app/models/widgets-validation/valdn-widgets-year.model";
import { AbstractClone } from "../../abstract/clone.abstract";
import { CloneRowService } from "./clone-row.service";
import { CloneColumnService } from "./clone-column.service";
import { WidgetsRadioModel } from "src/app/models/widgets/widgets-radio.model";
import { WidgetsCheckboxModel } from "src/app/models/widgets/widgets-checkbox.model";
import { WidgetsInputModel } from "src/app/models/widgets/widgets-input.model";
import { WidgetsTimeRangeModel } from "../../models/widgets/widgets-time-range.model";
import { ValdnWidgetsTimeRangeModel } from "../../models/widgets-validation/valdn-widgets-time-range.model";

@Injectable({
  providedIn: 'root'
})
export class CloneService extends AbstractClone {
  constructor(
    private logger: Logger,
    private injector: Injector,
    private cloneForm: CloneFormService,
    private cloneSection: CloneSectionService,
    private cloneQuestion: CloneQuestionService,
    private cloneRow: CloneRowService,
    private cloneColumn: CloneColumnService,
    private widgetsService: WidgetsService
  ) {
    super();
  }

  private cloneWidget(widget: any) {
    const newWidget = Object.create(widget);

    Object.defineProperty(newWidget, 'id', {
      value: null,
      writable: true
    });

    newWidget.updateId();

    return newWidget;
  }

  /**
   * Clone Label Overrides from an origin widget to a destination widget
   * @param originWidget Origin Widget
   * @param destWidget Destination Widget
   */
  public static cloneLabelOverrides(originWidget: WidgetsFormModel | WidgetsQuestionModel, destWidget: WidgetsFormModel | WidgetsQuestionModel) {
    // TODO: labelOverrides now copied TWO TIMES in QuestionModel AND FormModel. Decide where!!!

    // Label Overrides from JSON    
    if (originWidget && originWidget.labelOverrides) {
      let isOriginJs = true;
      let lblOvLength = Object.keys(originWidget.labelOverrides).length;

      if (originWidget.labelOverrides instanceof Map) {
        lblOvLength = originWidget.labelOverrides.size;
        isOriginJs = false;
      }

      if (lblOvLength > 0) {
        let worked: boolean = false;
        destWidget.labelOverrides = new Map<string, string>();

        let key: keyof typeof originWidget.labelOverrides;
        for (key in originWidget.labelOverrides) {
          worked = true;

          const value: any = originWidget.labelOverrides[key];
          if (value)
            destWidget.labelOverrides.set(key.toString(), value);
        }

        if (!worked) {
          // Like in 
          let keys = originWidget.labelOverrides.keys();
          let values = originWidget.labelOverrides.values();

          let stillKeys: boolean = true;
          while (stillKeys) {
            const key = keys.next().value;
            const value = values.next().value;

            if (key && value) {
              destWidget.labelOverrides.set(key.toString(), value);
            } else {
              stillKeys = false;
            }
          }
        }
        // destWidget.labelOverrides = widget.labelOverrides;
        // TODO: Maybe propagate labelOverrides to all the widgets below, or make them accessible?
      }
    }
  }

  /**
   * Recursive clone method 
   * Overcomes problems deserializing a typescript widget from JSON through HttpClient
   * @param origWidget Origin node to clone from, possibly loaded from a JSON file, without typing
   * @param destWidget Destination widget
   * @param isDragNDrop When cloning from layout for palette: false. When drag and dropping to create new instance: true. 
   * @param isInsideQuestion True if we are cloning inside a Question
   * @param parentId Id of the parent of the current node / null for top node
   */
  public cloneFromJS(origWidget: any, 
    destWidget: WidgetsAbstract, 
    isDragNDrop: boolean, 
    isInsideQuestion: boolean, 
    parentId: string | undefined) {

    try {
      const cloneClass = WidgetsConfigController.get(origWidget.widgetType)?.clone;
      const cloner : AbstractClone = this.injector.get<AbstractClone>( cloneClass );
      if (cloner) {
        cloner.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
      }

/*       switch (origWidget.widgetType) {
        // case WidgetsTypeEnum.FORM:
        //   this.cloneForm.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
        //   break;
        // case WidgetsTypeEnum.SECTION:
        //   this.cloneSection.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
        //   break;
        // case WidgetsTypeEnum.QUESTION:
        //   this.cloneQuestion.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
        //   break;
        // case WidgetsTypeEnum.ROW:
        //   this.cloneRow.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
        //   break;
        // case WidgetsTypeEnum.COLUMN:
        //   this.cloneColumn.cloneFromJS(origWidget, destWidget, isDragNDrop, isInsideQuestion, parentId);
        //   break;
        // case WidgetsTypeEnum.ARRAY:
        //   {
        //     // Fixed: Clone properly
        //     orgWidget = origWidget as WidgetsArrayModel;
        //     const newArray = new WidgetsArrayModel();
        //     newArray.parentId = parentId;
        //     const rowDest = destWidget as WidgetsColumnModel;
        //     rowDest.children.push(newArray);
        //     orgWidget.children.forEach(childWidget => {
        //       this.cloneFromJS(childWidget, newArray, isDragNDrop, isInsideQuestion, newArray.id);
        //     });
        //   }
        //   break;
        // case WidgetsTypeEnum.FIELD:
        // case WidgetsTypeEnum.RADIO:
        // case WidgetsTypeEnum.TIME_RANGE:
        // case WidgetsTypeEnum.CHECKBOX:
        // case WidgetsTypeEnum.INPUT:
        //   {
        //     let newInput;
        //     if (origWidget.widgetType == WidgetsTypeEnum.FIELD) {
        //       orgWidget = origWidget as WidgetsFieldModel;
        //       newInput = new WidgetsFieldModel();
        //       newInput.cloneFrom(orgWidget);
        //     } else if (origWidget.widgetType == WidgetsTypeEnum.RADIO) {
        //       orgWidget = origWidget as WidgetsRadioModel;
        //       newInput = new WidgetsRadioModel();
        //       newInput.cloneFrom(orgWidget);
        //     } else if(origWidget.widgetType == WidgetsTypeEnum.CHECKBOX){
        //       orgWidget = origWidget as WidgetsCheckboxModel;
        //       newInput = new WidgetsCheckboxModel();
        //       newInput.cloneFrom(orgWidget);
        //     } else if (origWidget.widgetType == WidgetsTypeEnum.TIME_RANGE) {
        //       orgWidget = origWidget as WidgetsTimeRangeModel;
        //       newInput = new WidgetsTimeRangeModel();
        //       newInput.cloneFrom(orgWidget);            
        //     } else if (origWidget.widgetType == WidgetsTypeEnum.INPUT) {
        //       orgWidget = origWidget as WidgetsInputModel;
        //       newInput = new WidgetsInputModel();
        //       newInput.cloneFrom(orgWidget);
        //     }
        //     newInput.parentId = parentId;

        //     // Only autoincrement key name with sequence IF NOT inside a CUSTOM WIDGET
        //     if (isDragNDrop && !isInsideQuestion) {
        //       // Change key
        //       const names: string[] = this.widgetsService.getAllFieldsOfType(orgWidget.type);
        //       if (names.length > 0)
        //         newInput.key = newInput.key + names.length;
        //     }

        //     const container = destWidget as WidgetsContainerAbstract;
        //     container.children.push(newInput);

        //     // Clone validations (input fields children are validations)
        //     if (orgWidget.children) {
        //       orgWidget.children.forEach(validationWidget => {
        //         this.cloneFromJS(validationWidget, newInput, isDragNDrop, isInsideQuestion, '');
        //       });
        //     }
        //   }
        //   break;
        // case WidgetsTypeEnum.TEXT:
        //   {
        //     orgWidget = origWidget as WidgetsTextModel;
        //     const newHeader = new WidgetsTextModel();
        //     newHeader.parentId = parentId;
        //     newHeader.label = orgWidget.label;
        //     newHeader.level = orgWidget.level;

        //     const container = destWidget as WidgetsContainerAbstract;
        //     container.children.push(newHeader);
        //   }
        //   break;        
        // case WidgetsTypeEnum.VALDN_DATE:
        //   {
        //     orgWidget = origWidget as ValdnWidgetsDateModel;
        //     const inputDest = destWidget as WidgetsFieldModel;
        //     const newValidation = new ValdnWidgetsDateModel();

        //     // TODO: Change validation labels as well
        //     newValidation.type = orgWidget.type;
        //     newValidation.template = orgWidget.template;
        //     inputDest.children.push(newValidation);
        //   }
        //   break;
        // case WidgetsTypeEnum.VALDN_TIMERANGE:
        //   {
        //     orgWidget = origWidget as ValdnWidgetsTimeRangeModel;
        //     const inputDest = destWidget as WidgetsFieldModel;
        //     const newValidation = new ValdnWidgetsTimeRangeModel();

        //     // TODO: Change validation labels as well
        //     newValidation.type = orgWidget.type;
        //     newValidation.template = orgWidget.template;
        //     inputDest.children.push(newValidation);
        //   }
        //   break;
        // case WidgetsTypeEnum.VALDN_YEAR:
        //   {
        //     orgWidget = origWidget as ValdnWidgetsYearModel;
        //     const inputDest = destWidget as WidgetsFieldModel;
        //     const newValidation = new ValdnWidgetsYearModel();

        //     // TODO: Change validation labels as well
        //     newValidation.type = orgWidget.type;
        //     newValidation.template = orgWidget.template;
        //     inputDest.children.push(newValidation);
        //   }
        //   break;
      } */
    } catch (error) {
      this.logger.log("src/app/cloneFromJS " + error);
    }
  }

  /**
   * 
   * FIXME: need ES2021.String library added to tsconfig.json
   * @param text 
   * @param map 
   * @returns 
   */
  public static overrideText(text: string | undefined, overrides: Map<string, string>) {
    if (text === undefined)
      return undefined;
      
    // TODO: parse and substitution
    // TODO: Move to util class
    let result: string = text;

    overrides.forEach((value: string, key: string) => {
      // Accepts regular expressions:
      // /gi + all ocurrences and case insensitive
      let regex = new RegExp("\\" + key, "g");
      result = result.replace(regex, value);
      // Works without regex, too:
      // result = result4.replace("$seq", value);
    });

    return result;
  }

  /**
   * Recurive method that adds the labelOverrides from all the hierarchy to a map.
   * Only Forms and Questions have labelOverrides as parameters in the model.
   * @param widget      Current widget to inspect
   * @param widgetRoot  Root of the widget tree
   * @param map         Contains all label overrides as key-value pairs from the hierarchy
   * @returns 
   */
  public static getLabelOverrides(widget: WidgetsAbstract, widgetRoot: WidgetsAbstract, map: Map<string, string>): boolean {
    let widgetModel;
    switch (widgetRoot.widgetType) {
      case WidgetsTypeEnum.QUESTION:
      case WidgetsTypeEnum.FORM:
        {
          widgetModel = widgetRoot as WidgetsContainerAbstract;

          // Label overrides are only allowed in FORMS and QUESTIONS.

          // TODO: Only propagate to ancestors of widget?
          // const isParentOfWidget: boolean = WidgetsService.isParentOfWidget(widgetRoot, widget);
          // if (model.labelOverrides && isParentOfWidget) {
          if (widgetModel.labelOverrides) {
            for (const [key, value] of widgetModel.labelOverrides.entries()) {
              map.set(key, value);
            }
            return true;
          }

          widgetModel.children.forEach(childWidget => {
            CloneService.getLabelOverrides(widget, childWidget, map);
          });
        }
        break;
      case WidgetsTypeEnum.ROW:
      case WidgetsTypeEnum.COLUMN:
      case WidgetsTypeEnum.ARRAY:
        {
          widgetModel = widgetRoot as WidgetsContainerAbstract;
          widgetModel.children.forEach(childWidget => {
            CloneService.getLabelOverrides(widget, childWidget, map);
          });
        }
        break;
      case WidgetsTypeEnum.FIELD:
      case WidgetsTypeEnum.TEXT:
        break;
    }
    return false;
  }
}


